export default __webpack_public_path__ + "static/media/hsa-guide.6e81e668.svg";